{
  "familyId": "TAA-SOORT-BNW",
  "questions": [
    {
      "id": "TAA-SOORT-BNW-001",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "multiple_choice",
      "question": "Welk woord is het bijvoeglijk naamwoord in deze zin? 'De grote hond rent door het park.'",
      "options": ["grote", "hond", "rent", "park"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijvoeglijk naamwoord herkennen",
            "content": "Een bijvoeglijk naamwoord (BNW) zegt iets over een zelfstandig naamwoord. Het geeft een eigenschap aan: hoe is iets? De grote hond → 'grote' zegt iets over de hond (hoe is de hond? → groot).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "adjective_identify_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Grote' is het bijvoeglijk naamwoord. Het zegt iets over de hond: hoe is de hond? → groot. Een bijvoeglijk naamwoord geeft een eigenschap aan van een zelfstandig naamwoord.",
        "solutionSteps": [
          "Zoek het woord dat een eigenschap aangeeft",
          "'Grote' zegt iets over 'hond'",
          "Hoe is de hond? → groot",
          "'Grote' = bijvoeglijk naamwoord ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Grote' is het bijvoeglijk naamwoord — het zegt iets over de hond.",
          "1": "'Hond' is een zelfstandig naamwoord (ZNW), niet een bijvoeglijk naamwoord. Een ZNW is een ding, dier of persoon. Onthoud: BNW = eigenschap, ZNW = ding.",
          "2": "'Rent' is een werkwoord (WW) — het geeft een handeling aan. Onthoud: WW = wat doe je?, BNW = hoe is iets?",
          "3": "'Park' is een zelfstandig naamwoord (ZNW) — het is een plek. Onthoud: BNW staat meestal vóór het ZNW en zegt er iets over."
        }
      }
    },
    {
      "id": "TAA-SOORT-BNW-002",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "multiple_choice",
      "question": "Hoeveel bijvoeglijke naamwoorden staan er in deze zin? 'Het kleine, bruine konijn zit in een donker hol.'",
      "options": ["3", "2", "1", "4"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meerdere BNW's herkennen",
            "content": "Zoek alle woorden die een eigenschap aangeven: 'kleine' (hoe is het konijn?), 'bruine' (welke kleur?), 'donker' (hoe is het hol?). Dat zijn 3 bijvoeglijke naamwoorden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "adjective_count_multiple",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Er zijn 3 bijvoeglijke naamwoorden: 'kleine' (eigenschap van konijn), 'bruine' (kleur van konijn), en 'donker' (eigenschap van hol). Elk woord dat een eigenschap aangeeft van een zelfstandig naamwoord is een BNW.",
        "solutionSteps": [
          "'Kleine' → eigenschap van konijn ✓",
          "'Bruine' → kleur van konijn ✓",
          "'Donker' → eigenschap van hol ✓",
          "Totaal: 3 bijvoeglijke naamwoorden"
        ],
        "distractorExplanations": {
          "0": "Goed! Er zijn 3 BNW's: kleine, bruine, donker.",
          "1": "Je hebt er waarschijnlijk eentje gemist. Vergeet 'donker' niet — dat zegt iets over het hol. Onthoud: zoek bij elk zelfstandig naamwoord of er een eigenschap bij staat.",
          "2": "Je hebt er twee gemist. Er zijn 3 BNW's: kleine, bruine, en donker. Onthoud: een zin kan meerdere BNW's bevatten.",
          "3": "Er zijn maar 3 BNW's, niet 4. Welk woord telde je extra mee? 'Konijn', 'zit', 'hol' zijn geen BNW's. Onthoud: alleen woorden die een eigenschap aangeven zijn BNW's."
        }
      }
    },
    {
      "id": "TAA-SOORT-BNW-003",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "multiple_choice",
      "question": "Welke zin bevat een bijvoeglijk naamwoord?",
      "options": ["De snelle auto reed voorbij.", "De auto reed voorbij.", "Hij reed snel voorbij.", "De auto reed en toeterde."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BNW vs. bijwoord",
            "content": "Een bijvoeglijk naamwoord staat bij een zelfstandig naamwoord: 'de snelle auto' (snelle = BNW bij auto). Een bijwoord staat bij een werkwoord: 'hij reed snel' (snel = bijwoord bij reed). Let op het verschil!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "adjective_vs_adverb",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'De snelle auto' bevat het BNW 'snelle' — het zegt iets over de auto. In 'hij reed snel' is 'snel' een bijwoord (het zegt iets over het werkwoord 'reed', niet over een zelfstandig naamwoord).",
        "solutionSteps": [
          "'De snelle auto' → 'snelle' zegt iets over 'auto' = BNW ✓",
          "'De auto reed voorbij' → geen eigenschap bij een ZNW",
          "'Hij reed snel' → 'snel' bij werkwoord = bijwoord, geen BNW",
          "'De auto reed en toeterde' → geen eigenschap"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Snelle' is een BNW — het zegt iets over de auto.",
          "1": "Deze zin heeft geen bijvoeglijk naamwoord. Er staat geen eigenschap bij 'auto'. Onthoud: een BNW geeft een eigenschap aan.",
          "2": "'Snel' in deze zin is een bijwoord, geen bijvoeglijk naamwoord. Het zegt iets over hoe hij reed (werkwoord), niet over een ding. Onthoud: BNW bij ZNW, bijwoord bij WW.",
          "3": "Deze zin heeft geen bijvoeglijk naamwoord. 'Reed' en 'toeterde' zijn werkwoorden. Onthoud: zoek woorden die een eigenschap aangeven van een ding."
        }
      }
    },
    {
      "id": "TAA-SOORT-BNW-004",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "multiple_choice",
      "question": "Vul aan: 'Dit is het ... schilderij van het museum.' Welke vorm past hier?",
      "options": ["mooiste", "mooier", "mooi", "mooieren"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Trappen van vergelijking",
            "content": "Bijvoeglijke naamwoorden hebben 3 trappen: stellende trap (mooi), vergrotende trap (mooier), overtreffende trap (mooiste). De overtreffende trap geeft het hoogste aan: het mooiste schilderij.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "adjective_superlative",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Het mooiste schilderij' — hier heb je de overtreffende trap nodig. De trappen zijn: mooi (stellend) → mooier (vergrotend) → mooiste (overtreffend). Bij 'het ... schilderij' past de overtreffende trap met -ste.",
        "solutionSteps": [
          "Stellende trap: mooi (basisvorm)",
          "Vergrotende trap: mooier (+er)",
          "Overtreffende trap: mooiste (+ste)",
          "'Het mooiste schilderij' = overtreffende trap ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Mooiste' is de overtreffende trap — het mooiste schilderij.",
          "1": "'Mooier' is de vergrotende trap, niet de overtreffende trap. Je gebruikt 'mooier' om twee dingen te vergelijken: 'dit schilderij is mooier dan dat'. Maar hier gaat het om het allermooiste. Onthoud: vergrotend = -er, overtreffend = -ste.",
          "2": "'Mooi' is de stellende trap (de basisvorm). 'Het mooi schilderij' klinkt niet goed — je hebt de overtreffende trap nodig: mooiste. Onthoud: stellend → vergrotend → overtreffend.",
          "3": "'Mooieren' bestaat niet. Je maakt de vergrotende trap met -er (mooier) en de overtreffende trap met -ste (mooiste). Je combineert nooit -er en -en. Onthoud: vergrotend = +er, overtreffend = +ste."
        }
      }
    },
    {
      "id": "TAA-SOORT-BNW-005",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "matching",
      "question": "Koppel elk bijvoeglijk naamwoord aan de juiste trap van vergelijking.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "groot", "right": "stellende trap"},
          {"left": "groter", "right": "vergrotende trap"},
          {"left": "grootst", "right": "overtreffende trap"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Trappen van vergelijking",
            "content": "Stellende trap = basisvorm (groot). Vergrotende trap = +er (groter). Overtreffende trap = +st (grootst/grootste).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "adjective_comparison_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Groot = stellende trap (basisvorm), groter = vergrotende trap (+er), grootst = overtreffende trap (+st).",
        "solutionSteps": [
          "Groot → stellende trap (basisvorm)",
          "Groter → vergrotende trap (+er)",
          "Grootst → overtreffende trap (+st)"
        ]
      }
    },
    {
      "id": "TAA-SOORT-BNW-006",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "categorize",
      "question": "Sorteer de woorden in de juiste categorie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Bijvoeglijk naamwoord", "Zelfstandig naamwoord", "Werkwoord"],
        "items": [
          {"text": "mooi", "correctCategory": 0},
          {"text": "tafel", "correctCategory": 1},
          {"text": "rennen", "correctCategory": 2},
          {"text": "klein", "correctCategory": 0},
          {"text": "school", "correctCategory": 1},
          {"text": "springen", "correctCategory": 2}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Woordsoorten herkennen",
            "content": "Bijvoeglijk naamwoord (BNW) = hoe is iets? (mooi, klein). Zelfstandig naamwoord (ZNW) = een ding, dier of persoon (tafel, school). Werkwoord (WW) = wat doe je? (rennen, springen).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "adjective_categorize_mixed",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bijvoeglijke naamwoorden geven een eigenschap aan: mooi (hoe is iets?), klein (hoe is iets?). Zelfstandige naamwoorden zijn dingen: tafel, school. Werkwoorden zijn handelingen: rennen, springen.",
        "solutionSteps": [
          "Mooi → hoe is iets? → bijvoeglijk naamwoord",
          "Tafel → een ding → zelfstandig naamwoord",
          "Rennen → wat doe je? → werkwoord",
          "Klein → hoe is iets? → bijvoeglijk naamwoord",
          "School → een ding → zelfstandig naamwoord",
          "Springen → wat doe je? → werkwoord"
        ]
      }
    }
  ]
}